// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import litepicker from 'litepicker';
import $ from 'jquery';

export default class RangeDatepicker extends WebComponent {
  didMount() {
    const targetInput = document.querySelector('#parameter-datum-konani_datepicker');
    const startDate = this.element.getAttribute('data-start-date');
    const endDate = this.element.getAttribute('data-end-date');

    if (targetInput.value.indexOf('L') == 0) {
      if (startDate == 0 || endDate == 0) {
        targetInput.value = '';
      }
      else {
        targetInput.value = startDate + ',' + endDate;
      }
    }

    this.litepicker = new litepicker({
      element: this.element,
      lang: 'cs-CZ',
      format: 'YYYYMMDD',
      numberOfMonths: 2,
      numberOfColumns: 2,
      selectBackward: false,
      singleMode: false,
      showTooltip: false,
      mobileFriendly: true,
      onSelect: () => {
          const thisValue = this.element.value.split(' - ');

          if (thisValue.length == 2) {
            thisValue[0] = this.makePseudoDecimal(thisValue[0]);
            thisValue[1] = this.makePseudoDecimal(thisValue[1]);
            targetInput.value = thisValue.join(',');
            $(targetInput).trigger('change');
          }
      },
      startDate: this.convertDate(startDate),
      endDate: this.convertDate(endDate),
    });
  }

  makePseudoDecimal(value) {
    return value.substring(0, 4) + '.' + value.substring(4);
  }

  convertDate(date) {
    let result = date.split('.').join('');
    if (result.length == 7) {
      result = result + '0';
    }
    if (result != 0) {
      return result;
    }
  }

  willUnMount() {
    this.litepicker.destroy();
  }
}



// WEBPACK FOOTER //
// ./fe/web-warehouse/src/js/components/RangeDatepicker.js